export default "__VITE_ASSET__7f95f976__"